import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCodeAssistant: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCodeAssistant"><Path fillRule="evenodd" clipRule="evenodd" d="M13 4V5L16.5 6.5L18 10H19L20.5 6.5L21 6.28516V21H3V3H15.333L13 4ZM6.58594 12L9.79297 15.207L11.207 13.793L9.41406 12L11.207 10.207L9.79297 8.79297L6.58594 12ZM12.793 10.207L14.5859 12L12.793 13.793L14.207 15.207L17.4141 12L14.207 8.79297L12.793 10.207Z" fill="currentColor"/><Path d="M18.5 1L19.4453 3.55468L22 4.5L19.4453 5.44532L18.5 8L17.5547 5.44532L15 4.5L17.5547 3.55468L18.5 1Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCodeAssistant;
